import styled from 'styled-components';

export const CardFlip = styled.div<{ isFlipped: boolean }>`
  width: 100%;
  height: 100%;
  transition: transform 0.4s ease-in-out;
  display: flex;
  transform-style: preserve-3d;
  position: relative;

  ${({ isFlipped }) =>
    isFlipped &&
    `
    transform: rotateY(180deg);
  `}
`;
